import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Tabs from '@ublique/components/Tabs'
import ButtonPanel from '@ublique/components/ButtonPanel'
import { Notification32, NotificationNew32 } from '@carbon/icons-react'
import { uniqueId } from 'lodash'

import NotificationTooltip from './NotificationTooltip'
import NotificationBlock from './NotificationBlock'
import useEventNotifications from './useEventNotifications'

import './index.scss'

const NotificationPanel = () => {
  const { t } = useTranslation([
    'NotificationPanelPlatform',
    'NotificationPanel'
  ])
  const [closePanel, setClosePanel] = useState()
  const { notifications, processes, setNotifications, notificationTooltip } =
    useEventNotifications([], {})

  const NotificationIcon = useMemo(() => {
    if (notifications.some((item) => !item.read)) {
      return NotificationNew32
    }
    return Notification32
  }, [notifications])

  const PanelContent = useMemo(() => {
    const processesList = Object.values(processes)
    return (
      <Tabs>
        <div title={t('NOTIFICATIONS')}>
          {notifications.length === 0 ? (
            <div className='notification-block'>
              <p>{t('NO_NOTIFICATIONS')}</p>
            </div>
          ) : (
            notifications.map((n) => (
              <NotificationBlock
                key={n.id}
                {...n}
                closePanel={() => setClosePanel(uniqueId())} // ButtonPanel component sets to false by default whenever the closePanel value is changed
              />
            ))
          )}
        </div>
        <div title={t('PROCESSES')}>
          {processesList.size === 0 ? (
            <div className='notification-block'>
              <p>{t('NO_PROCESSES')}</p>
            </div>
          ) : (
            processesList
              .sort((a, b) => b.timestamp - a.timestamp)
              .map((n) => <NotificationBlock key={n.id} {...n} />)
          )}
        </div>
      </Tabs>
    )
  }, [t, notifications, processes])

  useEffect(() => {
    const notificationPanelElement =
      document.getElementById('notification-panel')
    const notificationIcon =
      notificationPanelElement.getElementsByClassName('bx--btn__icon')
    if (notificationTooltip) {
      notificationIcon[0].classList.add('new-notification-animation')
    } else {
      notificationIcon[0].classList.remove('new-notification-animation')
    }

    if (notifications.some((item) => !item.read)) {
      notificationIcon[0]?.classList?.add('new-notification-icon')
    } else {
      notificationIcon[0]?.classList?.remove('new-notification-icon')
    }
  }, [notificationTooltip, notifications])

  const readAllNotifications = () => {
    if (
      notifications.length > 0 &&
      notifications.some((notif) => !notif.read)
    ) {
      setNotifications((notifications) =>
        notifications.map((notification) => ({ ...notification, read: true }))
      )
    }
  }

  return (
    <>
      <div id='notification-panel' onClick={readAllNotifications}>
        <ButtonPanel
          closePanel={closePanel}
          panelClassname='ublique-notification-panel'
          iconComponent={NotificationIcon}
          contentComponent={PanelContent}
        />
      </div>
      <NotificationTooltip notificationTooltip={notificationTooltip} t={t} />
    </>
  )
}

export default NotificationPanel
